<template>

  <v-card id="activity-center">
    <v-container class="pa-3">
      <h1 class="text-xs-center mb-3 subtle all-caps">Activity Center</h1>
      <v-layout column class="item-list">
        <!-- <p>Upcoming services and tasks list here</p> -->
        <template
          v-for='item in shifts'
        >
          <v-flex
            v-if='item.type == "shift"'
          >
            <ShiftItem
              showIcon
              wide
              :itemData='item'
            />
          </v-flex>

          <v-flex
            v-else-if='item.type == "task"'
          >
            <TaskItem
              showIcon
              :itemData='item'
            />
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapGetters  } from 'vuex'
import ShiftItem from '@/components/dashboard/shift-item.vue'
import TaskItem from '@/components/dashboard/task-item.vue'

export default {
  components: {
    ShiftItem,
    TaskItem
  },
  created () {
    // console.log(this.shifts)
    this.setUp()
  },
  computed: {
    ...mapState('userAuth', [
      'user'
    ]),
    activityItems () {
      return this.shifts
    },
    formattedQuery: function () {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
        locationFilter: this.selectedLocationFilter
      }
    },
  },
  methods: {
    getShifts: function () {
        const params = this.formattedQuery
        this.$store.dispatch('shifts/getList', params)
        .then(res => {
            this.shifts = res.shifts
        })
        .finally(res => {
        })
    },
    setUp: function () {
        this.startDate = this.startDate
        this.endDate = this.endDate
        this.selectedLocationFilter = this.user.clientWorksiteIds
        this.getShifts()
    }
  },
  data: function () {
    return {
        selectedLocationFilter: null,
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().add(1, "week").format("YYYY-MM-DD"),
        shifts: [],
    }
  },
}
</script>

<style scoped>
  #activity-center {
    height: 100%;
    max-height: 50vh;
    overflow: auto;
  }
  #activity-center .item-list {
    overflow: auto;
    /* max-height: 50vh; TODO: this is a hack. need to set up a fixed height viewport */
  }
</style>
